// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Plus_Jakarta_Sans_6b8127', '__Plus_Jakarta_Sans_Fallback_6b8127'","fontStyle":"normal"},"className":"__className_6b8127","variable":"__variable_6b8127"};